var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgPrinter = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17,6H3A3,3,0,0,0,0,9v6H4v4H16V15h4V9A3,3,0,0,0,17,6ZM14,17H6V12h8Zm3-7a1,1,0,1,1,1-1A1,1,0,0,1,17,10ZM16,1H4V5H16Z"
})));
export default SvgPrinter;